import React, { useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Hls from "hls.js";

const PreviewVideoModal = ({ source, title, ...rest }) => {
  const videoRef = useRef(null);

  const isHlsSource =
    source &&
    (source.includes("player.vimeo.com") || source.endsWith(".m3u8"));

  useEffect(() => {
    if (!isHlsSource || !source) return;

    const videoElement = videoRef.current;
    if (!videoElement) return;

    let hls;

    if (Hls.isSupported()) {
      hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
      });

      hls.loadSource(source);
      hls.attachMedia(videoElement);
    } else if (videoElement.canPlayType("application/vnd.apple.mpegurl")) {
      videoElement.src = source;
    } else {
      console.warn("HLS nije podržan u ovom browseru.");
    }

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [source, isHlsSource]);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const disableContextMenu = (e) => {
      e.preventDefault();
    };

    videoElement.addEventListener("contextmenu", disableContextMenu, false);

    return () => {
      videoElement.removeEventListener(
        "contextmenu",
        disableContextMenu,
        false
      );
    };
  }, [rest.show]);

  return (
    <Modal {...rest} centered className="video-preview-modal">
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className="modal-title"
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="video-preview-modal-body">
        <div>
          <video
            ref={videoRef}
            controls
            className="video-js"
            style={{
              width: "100%",
              height: "auto",
              maxHeight: "80vh",
              display: "block",
            }}
          >
            {!isHlsSource && source && (
              <source src={source} type="video/mp4" />
            )}
          </video>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PreviewVideoModal;